(function () {
    const notificationCloseButton = document.getElementById('js_notification-close');
    const banner = document.getElementById('js_notification');
    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }  

    function getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    document.addEventListener('DOMContentLoaded', (event) => {
        const hasCookie = getCookie("notificationClosed");
        if (!hasCookie && banner) {
            banner.classList.add("notification__open");
        }
    });

    if (notificationCloseButton) {
        notificationCloseButton.addEventListener("click", function (event) {
            banner.classList.remove("notification__open");
            setCookie("notificationClosed", true, 30);
        })
    }
}());